<app-dashboard-container
	class="dashboard-cijferlijst"
	[factTable]="factTable"
	(doExport)="this.doExport(filterExpressions(),[],$event)"
>
	<app-filter-panel
		[defaultFilters]="cijferlijstFilters"
		[allFilters]="allFilters()"
		(filterExpressionsChange)="filterExpressions.set($event)"
		endpoint="/cijfers"
	></app-filter-panel>
	<app-filter-bar [dataRootSelection]="dataRootSelection()"></app-filter-bar>
	<section class="dashboard">
		<app-dashboard-header>
			<app-single-select-dropdown
				label="Tekortpunten"
				[opties]="tekortpuntenKeuzeOpties"
				[selectedOptie]="getSelectedTekortpuntenOptie()"
				(onOptieClicked)="qp.dispatch('tekortpunten', $event)"
			></app-single-select-dropdown>
			<app-duo-select-dropdown
				label="Vaksortering"
				[optiesA]="vakOrderActiveOptions"
				[optiesB]="vakOrderDirectionOptions"
				[selectedOptieA]="vakOrderActive()"
				[selectedOptieB]="vakOrderDirection()"
				optieAHeader="Sorteren op"
				optieBHeader="Volgorde"
				(optieAClicked)="updateOptie($event, undefined)"
				(optieBClicked)="updateOptie(undefined, $event)"
			>
			</app-duo-select-dropdown>
			<app-legenda class="cl-header-utility" [attribute]="['x_cijfer_ov']"></app-legenda>
		</app-dashboard-header>
		<app-pivot-table
			[filters]="filterExpressions()"
			[permanentFilters]="[]"
			[tableGroups]="tableGroups()"
			[groups]="groups()"
			[subgroups]="subgroups"
			[columnSort]="sortColumn"
			[config]="this"
		></app-pivot-table>
	</section>
</app-dashboard-container>
